import Vue from 'vue'
import App from './components/App'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VuePaginate from 'vue-paginate'
// import VueAnalytics from 'vue-analytics'
import store from './store'
import VueCookies from 'vue-cookies'
import SocialSharing from 'vue-social-sharing'
import MetaInfo from 'vue-meta-info'
import './registerServiceWorker'

Vue.use(MetaInfo)
Vue.use(SocialSharing)
Vue.use(VueCookies)
Vue.use(VueRouter)
Vue.use(VueResource)
Vue.use(VuePaginate)

// config
Vue.config.productionTip = false
Vue.config.devtools = false

let apiurl = 'https://affiliate.i80.com.tw'

let token = localStorage.getItem('token')
if (token) {
  Vue.http.post(apiurl + '/api/checkToken', {
    token: token,
    source_from: 'web'
  }).then(function (res) {
    let data = res.body.data
    if (data.status === 200) {
      let user = {
        userId: localStorage.getItem('userId'),
        userName: localStorage.getItem('userName'),
        userEmail: localStorage.getItem('userEmail'),
        userPhone: localStorage.getItem('userPhone'),
        userCounty: localStorage.getItem('userCounty'),
        userDistrict: localStorage.getItem('userDistrict'),
        userAddress: localStorage.getItem('userAddress'),
        userCash: localStorage.getItem('userCash'),
        userValid: localStorage.getItem('userValid'),
        userStock: localStorage.getItem('userStock'),
        token: localStorage.getItem('token'),
        firstbuy: localStorage.getItem('firstbuy')
      }
      store.dispatch('LOGIN', user)
    } else {
      window.alert('您的登入時間已經到期，請重新登入會員。')
      store.dispatch('LOGOUT')
    }
  }, function () {
    console.log('Load user token')
  })
}

import data from './data'
import routes from './router'

if (data) {
  console.log('Load Success')
}

Vue.http.headers.common['Authorization'] = 'Basic YXBpOnBhc3N3b3Jk'

// router mode
const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes
})

// Vue.use(VueAnalytics, {
//   id: 'UA-42738541-1',
//   router
// })

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  // if (to.meta.requiresAuth && store.state.token === null) {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.state.home.token === undefined) {
      console.log('Not authenticated')
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  ...App
})



// WEBPACK FOOTER //
// ./src/main.js